import { useRef, useState } from 'react';
import { MoreHorizontal, KeyRound, UserX, UserCheck, Trash2 } from 'lucide-react';
import AnchoredPortal from './AnchoredPortal';

// Menu de ações da linha. Renderiza via AnchoredPortal (fora do contêiner
// arredondado/overflow da tabela) para não cortar na última linha — mesmo
// mecanismo de RoleCell/WorkspacesPopover/BoardsPanel: vira para cima quando
// falta espaço abaixo, limita na horizontal, fecha em Esc/clique fora/scroll/resize.
export default function UserRowMenu({ user, currentUserId, roleLocked, onResetPassword, onToggleActive, onDelete }) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const isSelf = user.id === currentUserId;
  const isActive = user.active !== false;

  const runAndClose = (action) => {
    setOpen(false);
    action(user);
  };

  return (
    <div className="relative">
      <button
        ref={btnRef}
        onClick={() => setOpen((v) => !v)}
        className="p-1 rounded hover:bg-white/10 text-text-secondary"
      >
        <MoreHorizontal className="w-4 h-4" />
      </button>
      {open && (
        <AnchoredPortal anchorRef={btnRef} onClose={() => setOpen(false)} width={192}>
          <div className="py-1">
            <button
              onClick={() => runAndClose(onResetPassword)}
              className="w-full flex items-center gap-2 px-3 py-2 text-xs text-text-primary hover:bg-white/5"
            >
              <KeyRound className="w-3.5 h-3.5" /> Redefinir senha
            </button>
            {!isSelf && !roleLocked && (
              <button
                onClick={() => runAndClose(onToggleActive)}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs text-text-primary hover:bg-white/5"
              >
                {isActive ? (
                  <><UserX className="w-3.5 h-3.5" /> Desativar usuário</>
                ) : (
                  <><UserCheck className="w-3.5 h-3.5" /> Reativar usuário</>
                )}
              </button>
            )}
            {!isSelf && !roleLocked && (
              <button
                onClick={() => runAndClose(onDelete)}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs text-danger hover:bg-danger/10"
              >
                <Trash2 className="w-3.5 h-3.5" /> Remover permanentemente
              </button>
            )}
          </div>
        </AnchoredPortal>
      )}
    </div>
  );
}
